// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"656ad647","272":"c5ac8e8b","354":"dee84cb6","453":"638661b9","657":"9bbb192d","742":"9296b1b1"}[chunkId] + ".chunk.js";
};